import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

const primengModules = [
  CalendarModule,
  DropdownModule,
  InputTextModule,
  ButtonModule,
  TableModule,
  ToastModule,
  BlockUIModule,
  ProgressSpinnerModule,
  SidebarModule,
  PanelMenuModule,
  OverlayPanelModule,
  PanelModule,
  DataViewModule,
  CardModule,
  CheckboxModule,
  BadgeModule,
  AvatarModule,
  DividerModule,
  TabViewModule,
  AccordionModule,
  RadioButtonModule,
  InputTextareaModule,
  PaginatorModule,
  BreadcrumbModule,
  TooltipModule,
  StepsModule,
  DialogModule,
  FileUploadModule,
  TimelineModule,
  PickListModule,
  ScrollTopModule,
  MultiSelectModule,
  AutoCompleteModule,
  SplitButtonModule,
  GalleriaModule,
  TreeModule,
  TreeTableModule,
  OrderListModule,
  TagModule,
  MenuModule,
  DynamicDialogModule,
  InputNumberModule,
  ChartModule,
  ProgressBarModule,
  InputSwitchModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [...primengModules],
})
export class PrimengModule {}
